import { ObjectValues } from 'types';

export const AuthEventTypes = {
  REFRESH_TOKEN_SUCCESS: 'REFRESH_TOKEN_SUCCESS',
  REFRESH_TOKEN_FAIL: 'REFRESH_TOKEN_FAIL',
  FORBIDDEN_SIGNAL: 'FORBIDDEN_SIGNAL',
  LOGOUT_SIGNAL: 'LOGOUT_SIGNAL',
  DR_FORBIDDEN_SIGNAL: 'DR_FORBIDDEN_SIGNAL',
  DR_LOGOUT_SIGNAL: 'DR_LOGOUT_SIGNAL',
  RFI_LOGOUT_SIGNAL: 'RFI_LOGOUT_SIGNAL',
} as const;

export const StandardEventTypes = {
  MESSAGE_SENT: 'MESSAGE_SENT',
  FILES_SENT: 'FILES_SENT',
  FILE_DELETE: 'FILE_DELETE',
  FILE_DELETED_WITH_MESSAGE: 'FILE_DELETED_WITH_MESSAGE',
  BULK_SESSION: 'BULK_SESSION',
  LISTING_SEARCH: 'LISTING_SEARCH',
  ACCESS_CYCLE_EVENT: 'ACCESS_CYCLE_EVENT',
  LEAD_WITHDRAW: 'LEAD_WITHDRAW',
  DATA_ROOM_NODE_ADDED: 'DATA_ROOM_NODE_ADDED',
  SHAREABLE_LINK_UPDATED: 'SHAREABLE_LINK_UPDATED',
} as const;

export type AuthEvents = ObjectValues<typeof AuthEventTypes>;
export type StandardEvents = ObjectValues<typeof StandardEventTypes>;

export type EventName = AuthEvents | StandardEvents;

export type CallbackBusType<T> = {
  event: EventName;
  payload: T;
};

export default {
  listeners: {} as Record<EventName, Array<any>>,
  addEventListener<T = any>(
    event: EventName,
    callback: (data: CallbackBusType<T>) => void,
  ) {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(callback);

    return () => {
      this.removeEventListener(event, callback);
    };
  },
  removeEventListener<T = any>(
    event: EventName,
    callback: (data: CallbackBusType<T>) => void,
  ) {
    this.listeners[event] = this.listeners[event].filter(
      (cb) => cb !== callback,
    );
  },
  broadcastEvent<T = any>(event: EventName, payload?: T) {
    if (this.listeners[event])
      this.listeners[event].forEach((cb) => cb({ payload, event }));
  },
  addMultiEventListener<T = any>(
    events: EventName[],
    callback: (data: CallbackBusType<T>) => void,
  ) {
    events.forEach((event) => {
      if (!this.listeners[event]) this.listeners[event] = [];
      this.listeners[event].push(callback);
    });
  },
  removeMultiEventListener<T = any>(
    events: EventName[],
    callback: (data: CallbackBusType<T>) => void,
  ) {
    events.forEach((event) => {
      this.listeners[event] = this.listeners[event].filter(
        (cb) => cb !== callback,
      );
    });
  },
};
